import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { notificationService } from "service/NotificationService";

import i18n from "i18n";

const t = (key, options) => i18n.t(key, options);

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isValidPhone(phone) {
  if (phone.startsWith("+")) {
    const pattern = /^\+\d{12}$/;
    return pattern.test(phone);
  } else {
    const pattern = /^\d{10}$/;
    return pattern.test(phone);
  }
}

export function isValidPhoneInput(input) {
  const pattern = /^[0-9+]*$/;
  return pattern.test(input);
}

export function toLocalDate(date) {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return year + "-" + month + "-" + day;
}

export function toGreekDate(localDate) {
  const wrongMessage = t("common.labels.invalidDate");

  if (!localDate) {
    return wrongMessage;
  }

  const split = localDate.split("-");

  if (!split || split.length !== 3) {
    return wrongMessage;
  }

  return `${split[2]}/${split[1]}/${split[0]}`;
}

export function serverTimesampToNormalDate(date, returnFormat = "DD/MM/YYYY HH:mm:ss") {
  if (!date) return "-";
  return moment.utc(date).format(returnFormat);
}

export function formatCurrency(value) {
  return new Intl.NumberFormat("el-GR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function exportToExcel(data, fileName, workSheetTitle) {
  try {
    if (data.length === 0) {
      notificationService.notifyError(t("messages.noDataIsAvailableForExport"));
      return;
    }
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    worksheet["!cols"] = [];
    for (let i = 0; i <= data.length; i++) {
      worksheet["!cols"].push({ wch: 25 });
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, workSheetTitle);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error fetching data:", error);
    notificationService.notifyError(error.message);
  }
}

export function getModeNameByid(modeId) {
  if (modeId === 1) return "TAKE AWAY";
  if (modeId === 2) return "DELIVERY";
  if (modeId === 3) return "RESTAURANT";
  if (modeId === 4) return "KIOSK";
  throw `Unknown modeId: ${modeId}`;
}

export function getIntegratorNameById(integratorId) {
  if (integratorId === 1) return "EFOOD";
  if (integratorId === 2) return "WOLT";
  if (integratorId === 3) return "BOX";
  if (integratorId === 5) return "GONNA ORDER";
  if (integratorId === 6) return "DELIVERY MANAGER";
  if (integratorId === 7) return "FLUTER";
  if (integratorId === 11) return "CULIZEN";
  if (integratorId === 14) return "ORDEROO";
}
